import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faSync, faFileEdit, faCheckCircle, faImage, faVideo, faExclamationTriangle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
import ReactPaginate from 'react-paginate';
import noDataImage from "../assets/nodata.png";
import { Modal, Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ViewAllTodaysPosts = () => {
  const navigate = useNavigate();
  const UserID = localStorage.getItem("UserID");
  const [todaysPosts, setTodaysPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const postsPerPage = 6;
  const [expandedPosts, setExpandedPosts] = useState({});
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [activeMedia, setActiveMedia] = useState(null);

  const styles = {
    pageWrapper: { border: 'none', backgroundColor: 'transparent' },
    headerBar: { borderRadius: '18px', padding: '18px 24px', backgroundColor: '#ffffff', border: '1px solid #eef0f8' },
    headerTitle: { fontSize: '22px', color: '#2e3192', fontWeight: 700, margin: 0 },
    gridRow: { marginTop: '24px' },
    card: { borderRadius: '22px', border: '1px solid #eef0f8', padding: '24px', backgroundColor: '#ffffff', minHeight: '100%', display: 'flex', flexDirection: 'column' },
    cardContent: { display: 'flex', flexDirection: 'column', gap: '20px', flexGrow: 1 },
    sectionTitle: { fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#858aad', fontWeight: 600, marginBottom: '8px' },
    scheduleHeading: { fontSize: '20px', color: '#2e3192', fontWeight: 700, marginBottom: '4px' },
    scheduleSubheading: { fontSize: '14px', color: '#6c7293', marginBottom: 0 },
    timezoneChip: { backgroundColor: '#eef0ff', color: '#2e3192', borderRadius: '999px', padding: '6px 12px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center' },
    statusBadge: { backgroundColor: '#f0fff4', color: '#28a745', borderRadius: '999px', padding: '6px 14px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center', marginTop: '8px' },
    metaStack: { display: 'flex', flexDirection: 'column', gap: '8px' },
    mediaWrapper: {
      position: 'relative',
      borderRadius: '22px',
      background: 'linear-gradient(135deg, rgba(46,49,146,0.12) 0%, rgba(107,99,255,0.08) 100%)',
      padding: '18px',
      marginTop: '20px',
      overflow: 'hidden'
    },
    mediaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
    mediaBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '12px',
      fontWeight: 700,
      color: '#2e3192',
      backgroundColor: '#ffffff',
      borderRadius: '999px',
      padding: '8px 14px',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      boxShadow: '0 4px 12px rgba(46,49,146,0.15)'
    },
    mediaPreviewShell: {
      borderRadius: '18px',
      backgroundColor: '#fff',
      padding: '12px',
      boxShadow: '0 8px 24px rgba(46,49,146,0.12)'
    },
    mediaPreview: {
      borderRadius: '14px',
      overflow: 'hidden',
      backgroundColor: '#0f172a',
      height: '220px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    mediaFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '14px',
      color: '#4f5480',
      fontSize: '12px'
    },
    mediaFilename: { fontWeight: 600, wordBreak: 'break-all' },
    captionSection: { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: '12px' },
    contentBox: { backgroundColor: '#f8f9ff', borderRadius: '18px', padding: '18px', color: '#34385b', whiteSpace: 'pre-wrap', flexGrow: 1, overflowY: 'auto' },
    promptBox: { backgroundColor: '#ffffff', border: '1px dashed #d9dcff', borderRadius: '18px', padding: '18px', color: '#4f5480' },
    pollBox: { backgroundColor: '#ffffff', border: '1px solid #eef0f8', borderRadius: '18px', padding: '18px', display: 'flex', flexDirection: 'column', gap: '10px' },
    pollQuestion: { fontWeight: 600, color: '#2e3192' },
    pollOption: { backgroundColor: '#f8f9ff', borderRadius: '12px', padding: '10px 14px', fontSize: '14px', color: '#4f5480' },
    actionIconButton: { borderRadius: '12px', border: '1px solid #eef0f8', backgroundColor: '#f7f8ff', padding: '10px 12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
    actionIcon: { fontSize: '20px' },
    actionsWrapper: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(52px, 1fr))', gap: '14px', marginTop: '16px', width: '100%' },
    toggleLink: { marginTop: '8px', fontWeight: 600, color: '#2e3192', cursor: 'pointer', border: 'none', background: 'transparent', padding: 0 },
  };

  const ActionButton = ({ icon, label, onClick, disabled, tooltip, variant = 'outline-primary' }) => {
    const variantColor = (() => {
      switch (variant) {
        case 'success':
          return '#28a745';
        case 'outline-danger':
          return '#ff4d4d';
        case 'outline-dark':
          return '#343a40';
        default:
          return '#2e3192';
      }
    })();

    const button = (
      <button
        type="button"
        className="btn btn-icon-only"
        style={{ ...styles.actionIconButton, opacity: disabled ? 0.6 : 1 }}
        onClick={onClick}
        disabled={disabled}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{ ...styles.actionIcon, color: variantColor }}
        />
        <span className="visually-hidden">{label}</span>
      </button>
    );

    if (!tooltip) {
      return button;
    }

    return (
      <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-${label.replace(/\s+/g, '-').toLowerCase()}`}>{tooltip}</Tooltip>}>
        <span className="d-inline-flex">{button}</span>
      </OverlayTrigger>
    );
  };

  const loadTodaysPosts = async () => {
    if (!UserID) return;

    setLoading(true);
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; 
      const todayDate = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/todays-posts/${UserID}?timezone=${timezone}&date=${todayDate}`);      let posts = response.data || [];
      
      // Sort posts by scheduled time in descending order (latest time first)
      posts.sort((a, b) => {
        // Helper function to parse time from ScheduledTimeAsPerZone or FormattedTime
        const parseTime = (post) => {
          // Try ScheduledTimeAsPerZone first
          if (post.ScheduledTimeAsPerZone) {
            const timeStr = post.ScheduledTimeAsPerZone.toString();
            const timeMatch = timeStr.match(/(\d{2}):(\d{2})/);
            if (timeMatch) {
              const hours = parseInt(timeMatch[1], 10);
              const minutes = parseInt(timeMatch[2], 10);
              return hours * 60 + minutes;
            }
          }
          
          // Try FormattedTime if available
          if (post.FormattedTime) {
            const timeStr = post.FormattedTime.toString();
            const timeMatch = timeStr.match(/(\d{2}):(\d{2})/);
            if (timeMatch) {
              const hours = parseInt(timeMatch[1], 10);
              const minutes = parseInt(timeMatch[2], 10);
              return hours * 60 + minutes;
            }
          }
          
          // Try ScheduleTime if available
          if (post.ScheduleTime) {
            const scheduleTime = new Date(post.ScheduleTime);
            if (!isNaN(scheduleTime.getTime())) {
              return scheduleTime.getHours() * 60 + scheduleTime.getMinutes();
            }
          }
          
          // Try to extract time from ScheduledPostDate
          if (post.ScheduledPostDate) {
            const scheduledDate = new Date(post.ScheduledPostDate);
            if (!isNaN(scheduledDate.getTime())) {
              return scheduledDate.getHours() * 60 + scheduledDate.getMinutes();
            }
          }
          
          return -1; // Return -1 for posts without time
        };
        
        const timeA = parseTime(a);
        const timeB = parseTime(b);
        
        // If both posts have valid times, sort by time (descending)
        if (timeA >= 0 && timeB >= 0) {
          if (timeA !== timeB) {
            return timeB - timeA; // Descending order
          }
        } else if (timeA >= 0 && timeB < 0) {
          return -1; // A has time, B doesn't - A comes first
        } else if (timeA < 0 && timeB >= 0) {
          return 1; // B has time, A doesn't - B comes first
        }
        
        // If times are equal or both missing, fall back to date comparison
        const dateA = a.ScheduledPostDate || a.CreatedDate || new Date(0);
        const dateB = b.ScheduledPostDate || b.CreatedDate || new Date(0);
        return new Date(dateB) - new Date(dateA);
      });
      
      setTodaysPosts(posts);
      setError('');
    } catch (error) {
      console.error('Error loading today\'s posts:', error);
      setTodaysPosts([]);
      setError('Failed to load today\'s posts');
      if (error.response?.status !== 404) {
        Swal.fire({
          icon: 'warning',
          title: 'Unable to load posts',
          text: 'There was an issue loading today\'s posts. Please try refreshing.',
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          position: 'top-end'
        });
      }
    } finally {
      setLoading(false);
    }
  };
  const formatScheduledTime = (value) => (value ? String(moment.parseZone(value, moment.ISO_8601, true).isValid() ? moment.parseZone(value, moment.ISO_8601, true).format('hh:mm A') : moment(value, 'HH:mm', true).isValid() ? moment(value, 'HH:mm', true).format('hh:mm A') : value).replace(' ', '\u00a0') : '');


  useEffect(() => {
    loadTodaysPosts();
  }, [UserID]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const offset = currentPage * postsPerPage;
  const currentPosts = todaysPosts.slice(offset, offset + postsPerPage);
  const pageCount = Math.ceil(todaysPosts.length / postsPerPage);

  const formatTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return moment(dateString).format('HH:mm');
    } catch (e) {
      return 'N/A';
    }
  };

  const getStatusIcon = (status, linkdinPostId, post) => {
    const statusUpper = status?.toUpperCase();
    // Check if this is a KnackFeed
    const isKnackFeed = post?.InterestsPromptID || post?.PostType === 'knack_feed' || post?.PostSource === 'knackfeed';
    
    // For KnackFeeds, treat PENDING and APPROVED as Approved
    if (isKnackFeed && (statusUpper === 'PENDING' || statusUpper === 'APPROVED')) {
      return <FontAwesomeIcon icon={faCheckCircle} size="sm" style={{ color: '#0d6efd' }} />;
    }
    
    // posted
    if (statusUpper === 'POSTED' || (statusUpper === 'APPROVED' && linkdinPostId && linkdinPostId.trim() !== '')) {
      return <FontAwesomeIcon icon={faCheckCircle} size="sm" style={{ color: '#28a745' }} />;
    }
    // approved but not posted yet
    if (statusUpper === 'APPROVED') {
      return <FontAwesomeIcon icon={faCheckCircle} size="sm" style={{ color: '#0d6efd' }} />;
    }
    // pending
    if (statusUpper === 'PENDING') {
      return <FontAwesomeIcon icon={faFileEdit} size="sm" style={{ color: '#ffc107' }} />;
    }
    return <FontAwesomeIcon icon={faFileEdit} size="sm" style={{ color: '#6c757d' }} />;
  };

  const getDisplayStatus = (status, linkdinPostId, post) => {
    const statusUpper = status?.toUpperCase();
    // Check if this is a KnackFeed
    const isKnackFeed = post?.InterestsPromptID || post?.PostType === 'knack_feed' || post?.PostSource === 'knackfeed';
    
    // For KnackFeeds, treat PENDING and APPROVED as Approved
    if (isKnackFeed && (statusUpper === 'PENDING' || statusUpper === 'APPROVED')) {
      return 'APPROVED';
    }
    
    if (statusUpper === 'POSTED' || (statusUpper === 'APPROVED' && linkdinPostId && linkdinPostId.trim() !== '')) {
      return 'POSTED';
    }
    if (statusUpper === 'APPROVED') {
      return 'APPROVED';
    }
    if (statusUpper === 'PENDING') {
      return 'PENDING';
    }
    return status || 'Unknown';
  };

  const resolveMediaDetails = (mediaPath = '') => {
    if (!mediaPath) return null;
    const normalized = `${mediaPath}`.trim();
    if (!normalized) return null;

    const isFullUrl = /^https?:\/\//i.test(normalized);
    const pathWithoutQuery = normalized.split('?')[0];
    const extension = pathWithoutQuery.split('.').pop()?.toLowerCase() || '';
    const filename = pathWithoutQuery.split(/[/\\]/).pop() || '';

    let mediaType = 'unknown';
    if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
      mediaType = 'video';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension)) {
      mediaType = 'image';
    }

    const source = encodeURI(isFullUrl ? normalized : `${process.env.REACT_APP_API_BASE_URL}/${normalized.replace(/\\/g, '/')}`);

    return {
      source,
      mediaType,
      filename,
    };
  };

  const renderMediaPreview = (mediaDetails) => {
    if (!mediaDetails) {
      return (
        <div className="text-muted">
          Media not available.
        </div>
      );
    }

    if (mediaDetails.mediaType === 'video') {
      return (
        <video controls style={{ width: '100%', height: '100%', maxHeight: '320px', borderRadius: '14px' }}>
          <source src={mediaDetails.source} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (mediaDetails.mediaType === 'image') {
      return (
        <img
          src={mediaDetails.source}
          alt="Post media"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      );
    }

    return (
      <div className="text-muted">
        Preview not available for this file type.
      </div>
    );
  };

  const getMediaIcon = (mediaType) => (mediaType === 'video' ? faVideo : faImage);

  const getMediaLabel = (mediaType) => {
    if (mediaType === 'video') return 'Video Attachment';
    if (mediaType === 'image') return 'Image Attachment';
    return 'Media Attachment';
  };

  const getMediaInteractionHint = (mediaType) => {
    if (mediaType === 'video') return 'Tap to play';
    if (mediaType === 'image') return 'Tap to zoom';
    return 'View media';
  };

  const getMediaFilename = (mediaDetails) => (mediaDetails ? mediaDetails.filename : '');

  const handleMediaPreviewClick = (mediaDetails) => {
    if (!mediaDetails || mediaDetails.mediaType === 'unknown') return;
    setActiveMedia(mediaDetails);
    setShowMediaModal(true);
  };

  const handleCloseMediaModal = () => {
    setShowMediaModal(false);
    setActiveMedia(null);
  };

  const renderModalMedia = () => {
    if (!activeMedia) return null;

    if (activeMedia.mediaType === 'video') {
      return (
        <video controls style={{ width: '100%', borderRadius: '12px' }}>
          <source src={activeMedia.source} />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (activeMedia.mediaType === 'image') {
      return (
        <img
          src={activeMedia.source}
          alt={activeMedia.filename || 'Preview'}
          style={{ width: '100%', borderRadius: '12px', objectFit: 'contain' }}
        />
      );
    }

    return null;
  };

  const toggleContent = (contentId) => {
    setExpandedPosts(prev => ({ ...prev, [contentId]: !prev[contentId] }));
  };

  const handlePrimaryAction = (post) => {
    // Check if this is a challenge post
    if (post.PostType === 'challenge') {
      navigate('/KnackChallenges');
      return;
    }
    
    // Check if this is a KnackFeed
    const isKnackFeed = post.InterestsPromptID || post.PostType === 'knack_feed' || post.PostSource === 'knackfeed';
    const contentId = post.ContentID || post.ContentId;
    
    if (isKnackFeed && contentId) {
      const status = (post.Status || '').toString().toUpperCase();
      // If posted, navigate to view page; otherwise navigate to update page
      if (status === 'POSTED' || (status === 'APPROVED' && post.LinkdinPostId && post.LinkdinPostId.trim() !== '')) {
        navigate(`/viewPostedAigeneratedschedulepost/${contentId}`);
      } else {
        navigate(`/updatelatesttrendingnews/${contentId}`);
      }
    } else if (post.ContentId) {
      const status = (post.Status || '').toString().toUpperCase();
      if (status === 'POSTED' || (status === 'APPROVED' && post.LinkdinPostId && post.LinkdinPostId.trim() !== '')) {
        navigate(`/viewPostedAigeneratedschedulepost/${post.ContentId}`);
      } else {
        navigate(`/updatependingpost/${post.ContentId}`);
      }
    }
  };

  const handleEditAction = (post) => {
    // Check if this is a KnackFeed
    const isKnackFeed = post.InterestsPromptID || post.PostType === 'knack_feed' || post.PostSource === 'knackfeed';
    const contentId = post.ContentID || post.ContentId;
    
    if (isKnackFeed && contentId) {
      navigate(`/updatelatesttrendingnews/${contentId}`);
    } else if (post.ContentId) {
      navigate(`/updatependingpost/${post.ContentId}`);
    }
  };

  const canEditPost = (post) => {
    const status = (post.Status || '').toString().toUpperCase();
    return status === 'PENDING';
  };

  return (
    <SideNavbar>
      <div className="container-fluid">
        <div className="card border-0 shadow-sm" style={{ borderRadius: '12px', marginTop: '20px' }}>
          <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center p-3">
            <div className="d-flex align-items-center">
              <div className="me-3">
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '8px',
                  background: '#f8f9fa',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #e9ecef'
                }}>
                  <FontAwesomeIcon icon={faChartLine} size={20} style={{ color: '#2e3192' }} />
                </div>
              </div>
              <div>
                <div className="d-flex align-items-center mb-1">
                  <Link to="/home" style={{ textDecoration: 'none', color: '#2e3192', marginRight: '15px' }}>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                  </Link>
                  <h5 className="mb-0 fw-bold me-2" style={{
                    fontSize: '1.3rem',
                    color: '#2e3192'
                  }}>
                    Today's Posts
                  </h5>
                  {!loading && (
                    <span className="badge bg-light text-dark" style={{ fontSize: '12px', fontWeight: '600' }}>
                      {todaysPosts.length}
                    </span>
                  )}
                </div>
                <small className="text-muted">All posts scheduled for today</small>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <button
                className="btn btn-sm btn-outline-primary me-2"
                onClick={loadTodaysPosts}
                disabled={loading}
                style={{
                  fontSize: '12px',
                  padding: '6px 12px',
                  borderRadius: '8px'
                }}
                title="Refresh today's posts"
              >
                <FontAwesomeIcon icon={faSync} size={10} />
              </button>
              {loading && (
                <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </div>
          </div>

          <div className="card-body p-4">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading posts...</span>
                </div>
                <p className="mt-3 text-muted">Loading today's posts...</p>
              </div>
            ) : error ? (
              <div className="text-center py-5">
                <p className="text-danger">{error}</p>
                <button className="btn btn-primary btn-sm" onClick={loadTodaysPosts}>
                  Try Again
                </button>
              </div>
            ) : todaysPosts.length === 0 ? (
              <div className="text-center py-5">
                <img src={noDataImage} alt="No data" style={{ width: '200px', height: '200px', opacity: 0.5 }} />
                <p className="mt-3 text-muted">No posts scheduled for today</p>
              </div>
            ) : (
              <>
                <div className="row">
                  {currentPosts.map((post, index) => (
                    <div key={`todays-post-${post.ContentId || post.PostId}-${index}`} className="col-md-4 mb-4">
                      <div
                        className="card border-0 shadow-sm h-100"
                        style={{
                          backgroundColor: '#f8f9fa',
                          borderRadius: '8px',
                          padding: '16px',
                          cursor: 'pointer',
                          transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                          minHeight: '250px'
                        }}
                        onClick={() => {
                          console.log('Post clicked - Full post object:', post);
                          console.log('InterestsPromptID:', post.InterestsPromptID);
                          console.log('ContentID:', post.ContentID);
                          console.log('ContentId:', post.ContentId);
                          
                          // Check if this is a challenge post
                          if (post.PostType === 'challenge') {
                            navigate('/KnackChallenges');
                            return;
                          }
                          
                          // Check if this is a KnackFeed (has InterestsPromptID, PostType='knack_feed', or PostSource='knackfeed')
                          const isKnackFeed = post.InterestsPromptID || post.PostType === 'knack_feed' || post.PostSource === 'knackfeed';
                          const contentId = post.ContentID || post.ContentId;
                          
                          if (isKnackFeed && contentId) {
                            // KnackFeed - route based on status
                            console.log('Detected as KnackFeed');
                            const status = (post.Status || '').toString().toUpperCase();
                            // If posted, navigate to view page; otherwise navigate to update page
                            if (status === 'POSTED' || (status === 'APPROVED' && post.LinkdinPostId && post.LinkdinPostId.trim() !== '')) {
                              navigate(`/viewPostedAigeneratedschedulepost/${contentId}`);
                            } else {
                              navigate(`/updatelatesttrendingnews/${contentId}`);
                            }
                          } else if (post.ContentId) {
                            // Regular post
                            console.log('Detected as regular post, routing to viewPostedAigeneratedschedulepost');
                            const status = (post.Status || '').toString().toUpperCase();
                            // POSTED status or APPROVED with LinkdinPostId should go to view page
                            if (status === 'POSTED' || (status === 'APPROVED' && post.LinkdinPostId && post.LinkdinPostId.trim() !== '')) {
                              navigate(`/viewPostedAigeneratedschedulepost/${post.ContentId}`);
                            } else {
                              navigate(`/updatependingpost/${post.ContentId}`);
                            }
                          } else {
                            console.warn('Post has no ContentId or ContentID:', post);
                          }
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                        }}
                      >
                        {/* Media Section (Image/Video) */}
                        {(() => {
                          const mediaPath = post.PostImage || post.Image || post.image || post.ImageURL;
                          if (mediaPath && mediaPath !== '/assets/default-post-image.png') {
                            const mediaDetails = resolveMediaDetails(mediaPath);
                            if (mediaDetails && mediaDetails.mediaType === 'video') {
                              // Show video preview
                              return (
                                <div className="mb-3">
                                  <video
                                    src={mediaDetails.source}
                                    controls
                                    style={{
                                      width: '100%',
                                      height: '120px',
                                      objectFit: 'cover',
                                      borderRadius: '6px'
                                    }}
                                  >
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              );
                            } else if (mediaDetails && mediaDetails.mediaType === 'image') {
                              // Show image preview
                              return (
                                <div className="mb-3">
                                  <img
                                    src={mediaDetails.source}
                                    alt={post.ShortContent || 'Post Image'}
                                    style={{
                                      width: '100%',
                                      height: '120px',
                                      objectFit: 'cover',
                                      borderRadius: '6px'
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                </div>
                              );
                            } else if (mediaPath) {
                              // Fallback: try to render as image if mediaDetails couldn't determine type
                              return (
                                <div className="mb-3">
                                  <img
                                    src={mediaPath.startsWith('http') ? mediaPath : `${process.env.REACT_APP_API_BASE_URL}/${mediaPath.replace(/\\/g, '/')}`}
                                    alt={post.ShortContent || 'Post Image'}
                                    style={{
                                      width: '100%',
                                      height: '120px',
                                      objectFit: 'cover',
                                      borderRadius: '6px'
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                </div>
                              );
                            }
                          }
                          // Show placeholder if no media
                          return (
                            <div className="mb-3" style={{
                              width: '100%',
                              height: '120px',
                              backgroundColor: '#e9ecef',
                              borderRadius: '6px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexDirection: 'column'
                            }}>
                              <i className="fa fa-file-image-o" style={{ fontSize: '24px', color: '#6c757d' }}></i>
                              <small style={{ color: '#6c757d', marginTop: '5px' }}>No image</small>
                            </div>
                          );
                        })()}

                        {/* Title Section */}
                        <div style={{ flex: '1 1 auto' }}>
                          {(() => {
                            // Check if this is a poll
                            const pollRequired = post.pollrequired === true || post.pollrequired === 1 || post.pollrequired === 'true' || post.pollrequired === '1';
                            
                            // Check if QuestionwithOptions exists and is valid
                            let pollData = null;
                            let hasValidPollData = false;
                            
                            if (post.QuestionwithOptions) {
                              try {
                                const parsedData = typeof post.QuestionwithOptions === 'string'
                                  ? JSON.parse(post.QuestionwithOptions)
                                  : post.QuestionwithOptions;
                                
                                // Check if it's a valid poll structure (has question and options)
                                if (parsedData && 
                                    typeof parsedData === 'object' && 
                                    parsedData.question && 
                                    Array.isArray(parsedData.options) && 
                                    parsedData.options.length > 0) {
                                  pollData = parsedData;
                                  hasValidPollData = true;
                                }
                              } catch (e) {
                                // If parsing fails or structure is invalid, it's not a poll
                                console.error('Error parsing poll data:', e);
                              }
                            }
                            
                            // Only consider it a poll if pollRequired is true OR we have valid poll data
                            const isPoll = pollRequired || hasValidPollData;
                            
                            return (
                              <>
                                <h6
                                  className="fw-bold mb-2"
                                  style={{
                                    color: '#2e3192',
                                    fontSize: '0.9rem',
                                    lineHeight: '1.4',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }}
                                >
                                  {isPoll ? 'Poll' : (post.ShortContent || post.Content || 'Untitled Post')}
                                </h6>
                                
                                {/* Show poll question below Poll title for polls */}
                                {isPoll && pollData && pollData.question && (
                                  <div className="small text-muted mt-1 mb-2" style={{
                                    fontSize: '0.75rem',
                                    lineHeight: '1.3',
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical'
                                  }}>
                                    {pollData.question}
                                  </div>
                                )}
                              </>
                            );
                          })()}

                          {/* Status and Time */}
                          <div className="d-flex align-items-center justify-content-between mt-3">
                            <div className="d-flex align-items-center">
                              {getStatusIcon(post.Status, post.LinkdinPostId, post)}
                              <small className="ms-2 text-muted" style={{ fontSize: '11px' }}>
                                {getDisplayStatus(post.Status, post.LinkdinPostId, post)}
                              </small>
                            </div>
                            <small className="text-muted" style={{ fontSize: '11px' }}>
                              {post.ScheduledTimeAsPerZone ? formatScheduledTime(post.ScheduledTimeAsPerZone)
                              // (() => {
                              //   // Format ScheduledTimeAsPerZone (e.g., "23:52:22.0000000" or "12:40:00")
                              //   const timeStr = post.ScheduledTimeAsPerZone.toString();
                              //   // Extract HH:MM from the time string
                              //   const timeMatch = timeStr.match(/(\d{2}):(\d{2})/);
                              //   if (timeMatch) {
                              //     return `${timeMatch[1]}:${timeMatch[2]}`;
                              //   }
                              //   return timeStr;
                              // })() 
                              : formatTime(post.ScheduledTime || post.CreatedDate)}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pagination */}
                {pageCount > 1 && (
                  <div className="d-flex justify-content-center mt-4">
                    <ReactPaginate
                      previousLabel={<span>&laquo;</span>}
                      nextLabel={<span>&raquo;</span>}
                      breakLabel={<span className="page-link">...</span>}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageChange}
                      containerClassName="pagination"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      activeClassName="active"
                      forcePage={currentPage}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </SideNavbar>
  );
};

export default ViewAllTodaysPosts;

